import {NEW_ID} from '../../../../common/constants/index.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import {showEndiciaCreditCardModal} from '../../../../redux/actions/ui/modals/endiciaCreditCardModal.js'
import {
  dispatch,
  getState,
  onlyIfAutoForm,
  useSelector,
} from '../../../../store.js'
import Nickname from './Nickname.js'
import ShippingMethods from './ShippingMethods.js'
import PostageBalance from './PostageBalance.js'
import {ENDICIA} from '../../../../common/constants/ShipperNames.js'
import {
  baseShipperFormErrorsSelector,
  baseShipperInitialFormSelector,
  simpleSaveShipper,
} from '../ShippersFunctions.js'

export function setUpShipperForm({shipper, formName}) {
  return {
    formName,
    initialForm: {
      ...initialFormSelector(getState(), {shipper}),
      errorsSelector,
    },
  }
}

export function errorsSelector(state, {formName}) {
  return baseShipperFormErrorsSelector(state, {formName})
}

export function initialFormSelector(state, {shipper}) {
  return baseShipperInitialFormSelector(state, {
    shipper,
    vendor: ENDICIA,
  })
}

export async function saveShipperEndicia(formName) {
  return simpleSaveShipper(formName)
}

function EndiciaForm({formName, form}) {
  const {id, isSaving} = form
  const errors = useSelector((state) => form.errorsSelector(state, {formName}))

  if (id === NEW_ID) {
    return null
  }

  return (
    <div className="settings-list-item-form-wrap settings-list-item-form-usps clear-both">
      <fieldset>
        <ul className="form-list medium-5 columns margin-bottom-0">
          <Nickname formName={formName} />
          <ShippingMethods formName={formName} />
          <li className="list__item list__item--no-style divider--bottom padding-bottom-20">
            <ButtonPrimary
              className="btn--primary-altm"
              isLoading={isSaving}
              isDisabled={errors.preventSave}
              onClick={() => saveShipperEndicia(formName)}
            >
              Update Nickname
            </ButtonPrimary>
          </li>
        </ul>
      </fieldset>
      <fieldset className="margin-bottom-0">
        <div className="medium-5 columns">
          <PostageBalance shipperID={id} />
        </div>
      </fieldset>
      <div className="medium-5 columns postage-wrap">
        <div className="postage-add margin-top-0">
          <ButtonPrimary
            size="sm"
            isOutlined
            onClick={() => dispatch(showEndiciaCreditCardModal(id))}
          >
            Update Credit Card
          </ButtonPrimary>
        </div>
      </div>
    </div>
  )
}

export default onlyIfAutoForm(EndiciaForm, setUpShipperForm)
